import * as tslib_1 from "tslib";
import * as React from 'react';
import { BaseComponent, classNamesFunction } from '../../Utilities';
var getClassNames = classNamesFunction();
/**
 * {@docCategory DocumentCard}
 */
var DocumentCardDetailsBase = /** @class */ (function (_super) {
    tslib_1.__extends(DocumentCardDetailsBase, _super);
    function DocumentCardDetailsBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentCardDetailsBase.prototype.render = function () {
        var _a = this.props, children = _a.children, styles = _a.styles, theme = _a.theme, className = _a.className;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className
        });
        return React.createElement("div", { className: this._classNames.root }, children);
    };
    return DocumentCardDetailsBase;
}(BaseComponent));
export { DocumentCardDetailsBase };
//# sourceMappingURL=DocumentCardDetails.base.js.map